import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { NextMethodsEnum } from '../enums/next-methods.enum';
import { HttpService } from '../http/http.service';
import { RetrieveAddressByGoogleBody, RetrieveAddressByGoogleReply } from './location.types';

@Injectable({
    providedIn: 'root'
})
export class LocationService {

    constructor(
        private http: HttpService
    ) { }

    retrieveGoogleAddress(body: RetrieveAddressByGoogleBody) {
        return this.http.post<RetrieveAddressByGoogleReply>(NextMethodsEnum.retrieveAddressByGoogle, body).pipe(
            map(reply => reply.address ?? [])
        );
    }

}
